/*
 * @deprecated TODO: use ActivityLogPropertyChangeType instead
 */
export enum HistoryChangeType {
  ADDED_PROPERTY = 'ADDED_PROPERTY',
  DELETED_PROPERTY = 'DELETED_PROPERTY',
  UPDATED_PROPERTY = 'UPDATED_PROPERTY',
  ARRAY_UPDATED = 'ARRAY_UPDATED',
}

/*
 * @deprecated TODO: use ManagementUser instead
 */
export enum HistoryChangeByType {
  STAFF = 'STAFF',
  TABLELIST = 'TABLELIST',
}

/*
 * @deprecated TODO: use ActivityLogDocumentType instead
 */
export enum HistoryDocumentType {
  ADMISSION_GROUP = 'ADMISSION_GROUP',
  CUSTOMER = 'CUSTOMER',
}

/*
 * @deprecated TODO: use ActivityLogChangeType instead
 */
export enum HistoryType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
}
